import { render, staticRenderFns } from "./purchase-order-details.vue?vue&type=template&id=f33f7c3e&scoped=true&"
import script from "./js/purchase-order-details.js?vue&type=script&lang=js&"
export * from "./js/purchase-order-details.js?vue&type=script&lang=js&"
import style0 from "./purchase-order-details.vue?vue&type=style&index=0&id=f33f7c3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f7c3e",
  null
  
)

export default component.exports